
module Meevo.Plugins.CompensationSettings {
  "use strict";

    export class SplitCommissionSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        addSplitCommission(_splitItem: Model.SplitCommissionSetting, index: number): void {

            if (Model.Guard.isNothing(this.model)) {

                this.model = <Model.SplitCommissionSettings>this.model;
            }
            if (Model.Guard.isNothing(this.model.splitCommissionSettingsList)) {

                this.model.splitCommissionSettingsList = [];
            }

            if (this.duplicateSplitCommission(_splitItem.displayName))
                return;

            this.model.splitCommissionSettingsList.push(_splitItem);

        }

        duplicateSplitCommission(displayName: string): boolean {
            var result = true;
            var check: any;
            if (_.find(this.model.splitCommissionSettingsList,
                (SC) => {

                    return ((<Model.SplitCommissionSetting>SC).displayName.toLowerCase() === displayName);
                    
                }) === undefined) {
                result = false;
            }
            return result;
        }
     

    removeSplitCommission(index: number): void {
          this.model.splitCommissionSettingsList.splice(index, 1);
      }
    }
}
